import { api } from '@/lib/api';

// Notizen zum Projekt (Schnell erfassen, pm-api routers/notizen.py). Eine
// Notiz ist eine core-Interaktion vom Typ note und steht damit auch im CRM
// beim Kunden. Autor und Zeitpunkt setzt der Server.

export interface Notiz {
  id: string;
  text: string;
  /** Anzeigename; null, wenn unbekannt. */
  autor: string | null;
  autor_id: string | null;
  zeitpunkt: string;
}

export const notizenApi = {
  list: async (projectId: string): Promise<Notiz[]> => {
    const { data } = await api.get(`/projects/${projectId}/notizen`);
    return data;
  },

  // Nur `text`: Das Backend lehnt unbekannte Felder mit 422 ab.
  create: async (projectId: string, text: string): Promise<Notiz> => {
    const { data } = await api.post(`/projects/${projectId}/notizen`, { text });
    return data;
  },
};
